import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { QUOTE_PRICING_FRAGMENT } from 'graphql/fragments/quote-pricing';
import { QUOTE_PRICING_STATE_FRAGMENT } from 'graphql/fragments/quote-pricing-state';
import { Mutation as RootMutation } from 'graphql/models/generated';

export const TOGGLE_ALTERNATIVE_POSITION_MUTATION = gql`
  mutation toggleAlternative(
    $documentVersion: DocumentVersionInput!
    $lineIds: [String!],
    $withPricing: Boolean = true
  ) {
    custom {
      toggleAlternative(
        documentId: $documentVersion
        lineIds: $lineIds
      ) {
        documentId
        lines {
          id
          customProperties {
            stringValue
            key
          }
        }
        ...QuotePricingFragment @include(if: $withPricing)
        ...QuotePricingStateFragment @skip(if: $withPricing)
      }
    }
  }
  ${QUOTE_PRICING_FRAGMENT}
  ${QUOTE_PRICING_STATE_FRAGMENT}
`;

@Injectable({
  providedIn: 'root'
})
export class ToggleAlternativePositionMutation extends Mutation<RootMutation> {
  document = TOGGLE_ALTERNATIVE_POSITION_MUTATION;
}
